export const CONTENT_WIDTH_PAGE = 1024;
export const contentWidthTokensCommon = {
  contentWidth: {
    page: {
      max: {
        value: 1024,
        unit: 'px'
      },
      min: {
        value: 280,
        unit: 'px'
      }
    }
  }
};
//# sourceMappingURL=contentWidthCommon.js.map